var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-alert',{attrs:{"show":""}},[_vm._v(_vm._s(_vm.getInnerCardDetail))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }